<template>
  <CalculationElementLayout
    :node-id="nodeId"
    :level="2">
    <v-row>
      <v-col>
        <v-container
          class="bordered bg-white mb-4"
          v-if="material">
          <template v-if="material.level === 2">
            <NormalInput
              :id="nodeId"
              class="mb-4"
              field="item_number" />

            <NormalInput
              :id="nodeId"
              class="mb-4"
              field="supplier" />

            <TaggedInput
              :id="nodeId"
              class="mb-4"
              field="manufacturing_feature"
              no-calculation />
          </template>

          <CalcInputNumber
            :id="nodeId"
            class="mb-4"
            field="material_price_material"
            :label="
              $t('entities.material.fields.material_price_material', {
                unit: material.unit_material
                  ? $t(
                      `entities.material.selects.unit_material.${material.unit_material}`
                    )
                  : ''
              })
            "
            :rules="[required, positive]" />

          <CalcInputSelect
            class="mb-4"
            :items="units"
            field="unit_material"
            :id="nodeId" />

          <CalcInputNumber
            :id="nodeId"
            class="mb-4"
            field="quantity_of_material_material"
            :label="
              $t('entities.material.fields.quantity_of_material_material', {
                unit: material.unit_material
                  ? $t(
                      `entities.material.selects.unit_material.${material.unit_material}`
                    )
                  : ''
              })
            "
            :rules="[required, positive]" />

          <CalcInputNumber
            v-if="material.level === 2"
            :id="nodeId"
            class="mb-4"
            field="interest_period_material_material" />
        </v-container>
        <v-container class="bordered bg-white">
          <NotesEditor
            :id="nodeId"
            field="comment"
            :placeholder="t('entities.material.fields.comment')" />
        </v-container>
      </v-col>
      <v-col>
        <CarouselWithUpload
          field="base-data"
          :node-id="nodeId" />
      </v-col>
    </v-row>
  </CalculationElementLayout>
</template>

<script setup>
import { computed, onMounted, ref, watch } from "vue";
import { useTranslation } from "i18next-vue";
import { useRoute } from "vue-router";

import { useCommonRules } from "@/validations/common";

import CarouselWithUpload from "@/components/Elements/CarouselWithUpload.vue";
import { useSpaceStore } from "../../stores/spaceStore";
import CalculationElementLayout from "@/layouts/CalculationElementLayout.vue";
import CalcInputSelect from "@/components/Elements/CalcInputSelect.vue";
import CalcInputNumber from "@/components/Elements/CalcInputNumber.vue";
import NotesEditor from "@/components/Elements/NotesEditor.vue";
import NormalInput from "@/components/Elements/NormalInput.vue";

const { t } = useTranslation();
const spaceStore = useSpaceStore();
const { required, positive } = useCommonRules(t);
const route = useRoute();

const nodeId = computed(() => route.params.nodeId);

const material = ref(null);

const loadElement = () => {
  material.value = spaceStore.getElement(nodeId.value);
};
watch(nodeId, () => {
  loadElement();
});

const units = computed(() => {
  const options = t(`entities.material.selects.unit_material`, {
    returnObjects: true
  });
  return Object.entries(options).map(([value, title]) => ({ value, title }));
});

onMounted(() => loadElement());
</script>
